import Vue from 'vue';
import Component from 'vue-class-component';
import { profileEntity } from "@/models/modules/profile/entity";
import { TranslateResult } from "vue-i18n";

@Component
export class Role extends Vue {

	directorLocal: string = 'role.director';
	accountantLocal: string = 'role.accountant';
	employeeLocal: string = 'role.employee';

	currentRole(accountant: any, director: any) {
		switch (profileEntity.profileData?.role) {
			case "ACCOUNTANT":
				return accountant;
			case "DIRECTOR":
				return director;
		}
	}

	get getCurrentRoleLocal(): TranslateResult {
		return this.$t((this as any)[profileEntity.profileData?.role?.toLowerCase() + 'Local'])
	}

	getRoleByLocal(key: string): TranslateResult {
		return this.$t((this as any)[key + 'Local'])
	}
}